import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "panel-content"
};
import { inject } from 'vue';
import { reactive, computed } from 'vue';
import { getDirectorOverviewPanelData, getRectorOverviewPanelData } from '@/api/index-guan';
import panelTab from './lib/panelTab';
import { formatSuitData } from '@/utils';
export default {
  __name: 'overviewPanel',
  props: {
    schoolId: {
      type: String,
      default: ''
    },
    cycle: {
      type: String,
      default: ''
    },
    cycleType: {
      type: String,
      default: ''
    },
    gradeId: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var props = __props;
    var active = inject('activeName', 'rector');
    var state = reactive({
      teacherNum: 0,
      classNum: 0,
      studentNum: 0,
      courseNum: 0,
      courseTimeNum: 0,
      courseRate: 0
    });
    var formatCourseTime = computed(function () {
      return function (time) {
        return formatSuitData(time);
      };
    });
    var getPanelOverview = function getPanelOverview() {
      var data = {
        schoolId: props.schoolId,
        cycle: props.cycle,
        cycleType: props.cycleType
      };
      if (active.value === 'rector') {
        getRectorOverviewPanelData(data).then(function (res) {
          var _res$data$data, _res$data$data2, _res$data$data3, _res$data$data4, _res$data$data5, _res$data$data6;
          // console.log(res)
          state.teacherNum = ((_res$data$data = res.data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.teacherNum) || 0;
          state.classNum = ((_res$data$data2 = res.data.data) === null || _res$data$data2 === void 0 ? void 0 : _res$data$data2.classNum) || 0;
          state.studentNum = ((_res$data$data3 = res.data.data) === null || _res$data$data3 === void 0 ? void 0 : _res$data$data3.studentNum) || 0;
          state.courseNum = ((_res$data$data4 = res.data.data) === null || _res$data$data4 === void 0 ? void 0 : _res$data$data4.courseNum) || 0;
          state.courseTimeNum = ((_res$data$data5 = res.data.data) === null || _res$data$data5 === void 0 ? void 0 : _res$data$data5.courseTimeNum) || 0;
          state.courseRate = ((_res$data$data6 = res.data.data) === null || _res$data$data6 === void 0 ? void 0 : _res$data$data6.courseRate) || 0;
        });
      } else {
        data.grade = props.gradeId;
        getDirectorOverviewPanelData(data).then(function (res) {
          var _res$data$data7, _res$data$data8, _res$data$data9, _res$data$data0, _res$data$data1, _res$data$data10;
          // console.log(res, 105)
          state.teacherNum = ((_res$data$data7 = res.data.data) === null || _res$data$data7 === void 0 ? void 0 : _res$data$data7.teacherNum) || 0;
          state.classNum = ((_res$data$data8 = res.data.data) === null || _res$data$data8 === void 0 ? void 0 : _res$data$data8.classNum) || 0;
          state.studentNum = ((_res$data$data9 = res.data.data) === null || _res$data$data9 === void 0 ? void 0 : _res$data$data9.studentNum) || 0;
          state.courseNum = ((_res$data$data0 = res.data.data) === null || _res$data$data0 === void 0 ? void 0 : _res$data$data0.courseNum) || 0;
          state.courseTimeNum = ((_res$data$data1 = res.data.data) === null || _res$data$data1 === void 0 ? void 0 : _res$data$data1.courseTimeNum) || 0;
          state.courseRate = ((_res$data$data10 = res.data.data) === null || _res$data$data10 === void 0 ? void 0 : _res$data$data10.courseRate) || 0;
        });
      }
    };
    __expose({
      getPanelOverview: getPanelOverview
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(panelTab), {
        toolContent: "课堂互动平台授课的教师总数",
        svgName: "teacher-num"
      }, {
        panelName: _withCtx(function () {
          return _toConsumableArray(_cache[0] || (_cache[0] = [_createTextVNode(" 教师数量 ", -1)]));
        }),
        panelNumber: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(state.teacherNum), 1)];
        }),
        _: 1
      }), _createVNode(_unref(panelTab), {
        toolContent: "课堂互动平台授课的班级总数",
        svgName: "class-num"
      }, {
        panelName: _withCtx(function () {
          return _toConsumableArray(_cache[1] || (_cache[1] = [_createTextVNode(" 班级数量 ", -1)]));
        }),
        panelNumber: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(state.classNum), 1)];
        }),
        _: 1
      }), _createVNode(_unref(panelTab), {
        toolContent: "课堂互动平台授课的学生总数",
        svgName: "teacher-num"
      }, {
        panelName: _withCtx(function () {
          return _toConsumableArray(_cache[2] || (_cache[2] = [_createTextVNode(" 学生数量 ", -1)]));
        }),
        panelNumber: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(state.studentNum), 1)];
        }),
        _: 1
      }), _createVNode(_unref(panelTab), {
        toolContent: "课堂互动平台授课的授课总数",
        svgName: "teach-num"
      }, {
        panelName: _withCtx(function () {
          return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode(" 发起课堂数 ", -1)]));
        }),
        panelNumber: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(state.courseNum), 1)];
        }),
        _: 1
      }), _createVNode(_unref(panelTab), {
        toolContent: "统计时间内所有授课的累计时长",
        svgName: "teach-all-time"
      }, {
        panelName: _withCtx(function () {
          return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode(" 总授课时长 ", -1)]));
        }),
        panelNumber: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(formatCourseTime.value(state.courseTimeNum)), 1)];
        }),
        _: 1
      }), _createVNode(_unref(panelTab), {
        toolContent: "平均每次授课的时长",
        svgName: "teach-time"
      }, {
        panelName: _withCtx(function () {
          return _toConsumableArray(_cache[6] || (_cache[6] = [_createTextVNode(" 平均授课时长 ", -1)]));
        }),
        panelNumber: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(formatCourseTime.value(state.courseRate)), 1)];
        }),
        _: 1
      })]);
    };
  }
};